import _ from 'lodash';
import md5 from 'js-md5';
import { APP_SECRET } from '@/config';

const APP_ID = 'default';

// 入参： params url解析过来的键值对
export default (params: { [key: string]: any }) => {
    const paramNew = params || {};

    paramNew.appid = APP_ID;
    paramNew.timestamp = new Date().getTime();
    // paramNew.request_source = 2;

    const parmaKeys = _.keys(paramNew);
    const parmaSort = _.sortBy(parmaKeys);
    // 组合,拼接字符串
    let joinSting = '';
    parmaSort.forEach((key) => {
        if (paramNew[key] !== undefined) {
            joinSting += key + paramNew[key];
        }
    });
    joinSting += APP_SECRET;
    const sgin = md5(encodeURI(joinSting));
    // console.log('获取传递过来的参数', prm, sobotTimestamp);
    const object = {
        // 验证信息 - 部分老接口需要
        // FIX：可能部分接口不需要这部分验证信息，需过滤
        appid: APP_ID,
        sign: sgin,
        timestamp: paramNew.timestamp,
        // 系统标识
        // request_source: 2,
    };

    // if (!option.noAccesskey) {
    //   object.accesskey = accesskey;
    //   object.sobot_timestamp = paramNew.sobot_timestamp;
    // }
    return object;
};
